<template>
<router-view />
</template>

<script>
export default {
  name: 'StatisticalAnalysisGHG',
  routeInfo: {
    label: '温室气体'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/02GHGAnalysis/index.vue